const costStructure = {
  vat: "5",
};

export default costStructure;
